/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import { useEffect, useMemo, useState } from 'react';

// Hook to fetch the /userApp response
const defaultObject = {};
// Always define the params object outside the component using it, otherwise
// you will keep rendering and re-rendering the component.
export const useFetchUserApplications = ({
    clientId = null,
    params = defaultObject,
    getOne // Return a single user
}) => {
    const [userApps, setUserApps] = useState(getOne ? {} : []);
    const [userAppsCount, setUserAppsCount] = useState(null);

    const [loading, setLoading] = useState(true);
    // calling refetchData will force a rerender on the hook
    const [shouldRefetchData, setShouldRefetch] = useState({});

    const refetchData = () => setShouldRefetch({});

    const parameters = useMemo(
        () =>
            clientId
                ? {
                      ...params,
                      includeClients: true,
                      platformTenantId: clientId
                  }
                : params,
        [clientId, params]
    );

    useEffect(() => {
        const { CancelToken } = axios;
        const source = CancelToken.source();

        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axios.get('/userApp', {
                    cancelToken: source.token,
                    params: parameters
                });
                if (!Response.hasData(response)) {
                    debug.e('No user application found.', response);
                } else if (getOne) {
                    setUserApps(Response.getOne(response));
                } else {
                    const allApps = Response.getData(response);
                    setUserAppsCount(allApps.length);
                    setUserApps(allApps);
                }
            } catch (error) {
                debug.e('Unable to get user application.', error);
            }
            setLoading(false);
        };
        fetchData();

        return () => {
            // Cancel the request when the component unmounts
            source.cancel();
        };
    }, [clientId, getOne, parameters, shouldRefetchData]);

    return {
        loading,
        refetchData,
        userApps,
        userAppsCount
    };
};
